// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myCards/stylesheet/style.scss
 ** module id = 455
 ** module chunks = 1
 **/